import Vue from 'vue'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import store from '@/store/store.js'
import pl_excm from '@/languages/pl/pl_excm.js' // eslint-disable-line

Vue.use(Vuex)
Vue.use(VueI18n)

const messages = {
  // polish language
  pl: pl_excm // eslint-disable-line
}

const i18n = new VueI18n({
  locale: store.state.language, // set locale
  messages // set locale messages
})

export default i18n
